import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConnectKitProvider } from 'connectkit';

import { wagmiConfig } from '../wagmiConfig';
const config = wagmiConfig;

const queryClient = new QueryClient();

const Disclaimer = () => {
  return (
    <div>
      <p>
        By using the Relend Network App you agree to the{' '}
        <a href="https://docs.relend.network/relend.docs/terms-and-conditions">terms and conditions</a>.
      </p>
    </div>
  );
};

export const Web3Provider = ({ children }: { children: React.ReactNode }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider options={{ disclaimer: <Disclaimer /> }}>{children}</ConnectKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};
